const Back = () => {
  return (
    <>
      <svg
        className="icon"
        width="30"
        height="20"
        viewBox="0 0 30 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M11.0283 0.687128C10.9723 0.552162 10.8902 0.42957 10.7868 0.326375C10.6836 0.222919 10.561 0.140838 10.426 0.0848329C10.2911 0.0288281 10.1464 -4.22594e-08 10.0003 -4.86468e-08C9.85413 -5.50341e-08 9.70944 0.0288281 9.57447 0.0848329C9.43951 0.140838 9.31691 0.222919 9.21372 0.326375L0.326335 9.21376C0.222878 9.31695 0.140797 9.43955 0.0847927 9.57451C0.0287881 9.70948 -4.04851e-05 9.85417 -4.04914e-05 10.0003C-4.04978e-05 10.1464 0.0287881 10.2911 0.0847926 10.4261C0.140797 10.561 0.222878 10.6836 0.326334 10.7868L9.21372 19.6742C9.42232 19.8828 9.70524 20 10.0003 20C10.2953 20 10.5782 19.8828 10.7868 19.6742C10.9954 19.4656 11.1126 19.1827 11.1126 18.8877C11.1126 18.5927 10.9954 18.3097 10.7868 18.1011L2.68371 10.0003L10.7868 1.89944C10.8902 1.79625 10.9723 1.67366 11.0283 1.53869C11.0843 1.40372 11.1132 1.25903 11.1132 1.11291C11.1132 0.966784 11.0843 0.822095 11.0283 0.687128Z"
          fill="black"
        />
        <rect x="2" y="9" width="28" height="2" rx="1" fill="#221E1F" />
      </svg>
    </>
  );
};

export default Back;
